<template>
	<div>

		<div v-if="!lista_dados.length">

			<az-empty-state action="Incluir" :method="addNewItem"></az-empty-state>

		</div>

		<pre v-if="1 == 0">{{ lista_dados }}</pre>

		<div v-if="firstLoadDone && lista_dados.length && !em_edicao">

			<table class="table table-striped table-responsive-md table-light">
				<thead>
					<tr>
						<th width="5%">
							<button type="button" class="btn btn-success btn-sm" @click="addNewItem()">	
								<i class="fas fa-plus"></i>
							</button>
						</th>
						<th v-for="(campo, index) in lista_campos" :key="index">
							{{ campo.display }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in lista_dados" :key="index">
						<td>
							<button type="button" class="btn btn-success btn-sm mr-2" @click="editar(item)">	
								<i class="fas fa-pen"></i>
							</button>
						</td>
						<td v-for="(campo, index) in lista_campos" :key="index">
							{{ resolve (campo.name, item) }}
						</td>
					</tr>
				</tbody>
				<tfoot>
					<tr>
						<td colspan="1000">
							<div class="d-flex justify-content-between">
								<div>
									<div class="input-group mb-0">
										<input type="search" class="form-control" placeholder="Pesquisar..."
											autocomplete="off" name="s" v-model="search"
											@change="pesquisar ()">
									</div>
								</div>
								<div>
									<nav v-if="lista.data.last_page > 1">
										<paginate
											class="mb-0"
											:page-count="lista.data.last_page"
											:container-class="'pagination'"
											:page-class="'page-item'"
											:page-link-class="'page-link'"
											:prev-class="'page-link'"
											:next-class="'page-link'"
											:prev-text="'<<'"
											:next-text="'>>'"
											:click-handler="recarregar">
										</paginate>
									</nav>
								</div>
							</div>
						</td>
					</tr>
				</tfoot>
			</table>

			<!-- Modal -->
			<div class="modal fade" id="cadastroModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
				<div class="modal-dialog modal-lg" role="document">
					<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel">{{ campos.data.title }}</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body" v-if="item">
						<cadastro-form 
							ref="cadForm"
							:selectOptions="selectOptions"
							:campos="campos.data.edit_fields" 
							:registro="item"
							:saveItem="saveItem"></cadastro-form>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
						<button type="button" class="btn btn-primary" @click="saveForm ()">Atualizar</button>
					</div>
					</div>
				</div>
			</div>

		</div>

		<!-- Formulário -->
		<div v-if="em_edicao">
			<div class="card" style="padding: 0px;">
				<div class="card-header">
					<span class="lead">{{ campos.data.title }}</span>
				</div>
				<div class="card-body">
					<cadastro-form 
						:selectOptions="selectOptions"
						:campos="campos.data.edit_fields" 
						:registro="item">
					</cadastro-form>
				</div>

				<!-- SubCadastros mode card -->
				<div v-for="(child, index) in lista_childs_in" :key="index">
					<div class="card-header">
						<span class="lead">{{ child.name }}</span>
					</div>
					<div class="card-body">
						<div v-if="child.type == 'one'">
							<cadastro-form 
								:ref="'cadForm-c-' + index"
								:selectOptions="selectOptions"
								:campos="child.metadados.edit_fields" 
								:registro="getData(item, child.morph)"
								:saveItem="saveItem"
								v-if="child.type == 'one'">
							</cadastro-form>
						</div>
						<div v-else>
							<cadastro-detail-list :data="getData(item,child.morph)" :metadados="child"></cadastro-detail-list>
						</div>
					</div>
				</div>

				<!-- Botões de Atualização -->

				<nav class="navbar fixed-bottom navbar-light bg-light pb-3 mb-2">
					<div>
						<button class="btn btn-success mr-2">Atualizar</button>
						<button class="btn btn-secondary mr-2" @click="fechar ()">Fechar</button>
						<button class="btn btn-outline-danger">Excluir</button>
					</div>
				</nav>
			</div>

			<!-- Detail do Cadastro -->

			<div v-if="lista_childs_tab.length">
				<ul class="nav nav-tabs" id="myTab" role="tablist">
					<li class="nav-item" v-for="(child, index) in lista_childs_tab" :key="index">
						<a class="nav-link" :class="index ? '' : 'active'" :id="'t-' + index + '-tab'" data-toggle="tab" 
							:href="'#t-' + index" role="tab" aria-controls="home" aria-selected="true">
							{{ child.name }}
						</a>
					</li>
					<li class="nav-item">
						<a class="nav-link" id="child-tab" data-toggle="tab" href="#child" role="tab" 
							aria-controls="child" aria-selected="true">
							JSON
						</a>
					</li>
				</ul>

				<div class="tab-content">
					
					<div class="tab-pane" :class="index ? '' : 'active'" :id="'t-' + index" role="tabpanel" aria-labelledby="home-tab"
						v-for="(child, index) in lista_childs_tab" :key="index">

						<div class="mt-3" v-if="child.type == 'one'">

							<div class="card">

								<div class="card-body">

									<cadastro-form 
										:ref="'cadForm-t-' + index"
										:selectOptions="selectOptions"
										:campos="child.metadados.edit_fields" 
										:registro="item[child.morph]"
										:saveItem="saveItem"></cadastro-form>

								</div>

								<div class="card-footer">
									<button class="btn btn-outline-primary mr-2">Atualizar</button>
								</div>

							</div>

						</div>

						<div class="mt-3" v-else>
							<cadastro-detail-list :data="item[child.morph]" :metadados="child"></cadastro-detail-list>
						</div>
						
					</div>

					<div class="tab-pane" id="child" role="tabpanel" aria-labelledby="child-tab">
						<pre class="mt-3">{{campos.data.list_childs}}</pre>
					</div>

				</div>
			</div>
			<br><br>
		</div>

	</div>
</template>

<script>

	import _ from 'lodash';
	import $ from 'jquery';

	export default {
		data () {
			return {
				filters: {},
				dialogVisible: false, 
				selectedItem: null,
				item: null, 
				geral: {},
				model: "", 
				lista: { data: { data: [] } },
				campos: [],
				campos_edicao: [],
				formErrors: [], 
				edicao: [],
				chave: "", 
				loading: true,
				last_page: 0,
				em_edicao: false,
				filhos: [],
				dados: {},
				reloading: false,
				search: "",
				firstLoadDone: false,
				breadcrumb: [],
				selectOptions: null
			}
		},
		props: {
			title: String,
			parentKey: Number,
			parentModel: String
		},
		computed: { 
			lista_childs_in () { 
				if ( !this.campos.data.list_childs )
					return [];

				return _.filter(this.campos.data.list_childs, (item) => { 
							return item.mode == 'card';
						});
			},
			lista_childs_tab () { 
				if ( !this.campos.data.list_childs )
					return [];

				return _.filter(this.campos.data.list_childs, (item) => { 
							return item.mode != 'card';
						});
			},
			lista_campos () { 
				return this.campos.data.list_fields.filter((item) => { 
								return !item['hide'];
							});
			},
			lista_dados () { 
				return this.lista.data.data ? this.lista.data.data : [];
			}
		},
		methods: { 
			getData (item, field) { 
				return _.get(item, field);
			},
			addNewItem () { 
				this.item = null;
				this.editar ({});
			},
			saveForm () { 
				this.$refs.cadForm.salvar ();
			},
			saveItem (item = null) { 

				if ( item )
					this.item = item;

				this.reloading = true;

				let query = { 
								q: [ 
									{ 
										name: this.model + '.store', 
										parms: { ...this.item }, 
										id: 'salvar'
									}
								]
							};

				this.axios.post('aql', query)
					.then (res => { 
						if ( res.data.salvar && res.data.salvar.data && res.data.salvar.data.status_code > 400 ) { 
							let error = { 
										response: { 
											status: res.data.salvar.data.status_code, 
											data: { errors: res.data.salvar.data.msg }
										}
									};
							this.handleError(error);
						} else { 
							this.load();
							if ( $("#cadastroModal") ) { 
								$("#cadastroModal").modal('hide');
							}
						}
					})
					.catch (() => { 
						this.loading = false;
						this.reloading = false;
					});
			},
			deleteItem () { 
				this.reloading = true;

				let query = { 
								q: [ 
									{ 
										name: this.model + '.destroy', 
										parms: { ...this.item }, 
									}
								]
							};

				this.axios.post('aql', query)
					.then (() => { 
						this.dialogVisible = false;
						this.load();
					})
					.catch (err => { 
						this.loading = false;
						this.reloading = false;
						this.handleError(err);
					});
			},
			editar (item) { 
				this.item = null;

				this.loadOptions ()
					.then (() => { 

						this.item = item;
					
						if ( this.campos.data.list_childs.length ) {
									
							this.em_edicao = true;

							if ( this.campos.data.description ) { 
								let bc = _.cloneDeep(this.breadcrumb);
								bc.push({ name: this.item[this.campos.data.description], path: "" });
								this.$store.commit('setBreadcrumb', bc);
							}

						} else { 

							$('#cadastroModal').modal('show');

						}

					});

			},
			onRowSelect(event) {
				this.item = null;
				this.editar ({...event.data});
			},
			recarregar(page) {
				this.reloading = true;
				this.load(page);
			},
			loadOptions () { 
				if ( this.selectOptions )
					return new Promise(function(resolve) {
								resolve();
							});

				let query = [];

				_.each(this.campos.data.edit_fields, (item) => {
						if ( item.type == 'select' && item.aql ) 
							query.push(item.aql);
					});

				_.each(this.campos.data.list_childs, (item) => { 
						_.each(item.metadados.edit_fields, (item) => {
								if ( item.type == 'select' && item.aql ) 
									query.push(item.aql);
							});
					});

				query = { q: query };

				this.$store.commit('loading', true);

				return this.axios.post('aql', query)
							.then (res => { 
								this.selectOptions = res.data;
							})
							.catch (err => { 
								this.handleError(err);
							})
							.finally (() => { 
								this.$store.commit('loading', false);
							});
			},
			load (page = 1) { 

				this.last_page = page;

				/*
				if ( this.$props.parentModel ) {
					parms = parms + '&pm=' + this.$props.parentModel;
					parms = parms + '&pk=' + this.$props.parentKey;
				}
				*/

				this.$store.commit('loading', true);

				let query = { q: [ 
									{ 
										name: this.model + '.index', 
										id: "lista",
										parms: { page: page, search: this.search }
									},
									{ 	
										name: this.model + '.create',
										id: "campos"  
									},
								]};

				this.axios.post('aql?page=' + page, query)
					.then (res => { 
						this.lista = res.data.lista;
						this.campos = res.data.campos;
						
						if ( this.loading ) { 
							this.breadcrumb = [
									{ name: "Configurações", path: "/cadastros"},
									{ name: this.campos.data.title, method: this.fechar }
								];
							this.$store.commit('setBreadcrumb', this.breadcrumb);
						}

						this.loading = false;
						
					})
					.catch (err => { 
						this.loading = false;
						this.reloading = false;
						this.handleError(err);
					})
					.finally (() => { 
						this.$store.commit('loading', false);
						this.firstLoadDone = true;
					});
			},
			pesquisar () { 
				this.reloading = true;
				this.load ();
			},
			incluir () { 
				//let self = this;

				this.edicao = { _novo: true };

				/*
				_.forEach(this.campos_edicao, function (c) { 
						self.edicao[c.name] = "";
					});
				*/

				//$('#cadastroModal').modal('show');
			},
			atualizar () { 
				this.axios.post('/api/' + this.$props.model, this.edicao)
					.then (() => { 
						this.carregar(this.last_page);
						//$('#cadastroModal').modal('hide');	
					})
					.catch (err => this.handleError(err));
			},
			excluir (item) {
				this.axios.delete('/api/' + this.$props.model + '/' + item[this.chave])
					.then (() => { 
						this.carregar(this.last_page);
					})
					.catch (err => this.handleError(err));	
			},
			fechar () { 
				this.em_edicao = false;
				this.$store.commit('setBreadcrumb', this.breadcrumb);
			},
			resolve(path, obj) {
				return path.split('.').reduce(function(prev, curr) {
					return prev ? prev[curr] : null
				}, obj || self);
			}
		},
		mounted() { 
			this.model = this.$props.parentModel ? this.$props.parentModel : this.$route.params.model;
			this.load ();
		}
	}

</script>
